<template>
  <q-table
    v-model:pagination="pagination"
    title=""
    :rows="customers"
    :columns="columnDefinition"
    :loading="loading"
    row-key="id"
    :rows-per-page-options="[]"
    @request="onRequest"
  >
    <template #body="props">
      <q-tr :props="props">
        <q-td key="name" :props="props">
          {{ props.row.name }}
        </q-td>
        <q-td key="gender" :props="props">
          {{ mappers.genderMapper(props.row.gender) }}
        </q-td>
        <q-td key="email" :props="props">
          {{ props.row.email }}
        </q-td>
        <q-td key="phone" :props="props">
          {{ props.row.phone }}
        </q-td>
        <q-td key="medical" :props="props">
          <q-chip v-for="med in props.row.medical" :key="med" square>
            <q-avatar icon="monitor_heart" color="red" text-color="white" />
            {{ med }}
          </q-chip>
        </q-td>
        <q-td key="activeSubscriptions" :props="props">
          <q-chip
            v-for="subs in props.row.activeSubscriptions"
            :key="subs.purchaseId"
            square
          >
            <q-avatar icon="paid" color="secondary" text-color="white" />
            {{ subs.subscriptionTitle }}
          </q-chip>
        </q-td>
        <q-td key="actions" :props="props">
          <div class="q-pa-md q-gutter-sm">
            <q-btn
              label="Git"
              icon="info"
              color="primary"
              no-caps
              @click="onRowClicked(props.row.id)"
            />
            <EditCustomer :customer="props.row" />
            <DeleteCustomer :customer-id="props.row.id" />
          </div>
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
import EditCustomer from '../customer/Edit.vue'
import DeleteCustomer from '../customer/Delete.vue'
import { ref, inject } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import * as eventNames from '../../utils/events'
import * as columns from '../../utils/columns'
import * as mappers from '../../utils/mapper'
export default {
  components: {
    EditCustomer,
    DeleteCustomer,
  },
  setup() {
    const router = useRouter()
    const loading = ref(false)
    const pagination = ref({
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 0,
    })
    const customers = ref([])
    const columnDefinition = columns.CUSTOMER_COLUMNS
    const emitter = inject('emitter')
    emitter.on(eventNames.REFRESH_CUSTOMERS, () => {
      fetchFromServer(0, 10)
    })

    function fetchFromServer(page, size) {
      loading.value = true
      axios
        .get(`/customers?page=${page}&size=${size}`)
        .then((response) => {
          customers.value = response.data
        })
        .finally(() => {
          loading.value = false
        })
    }

    function getRowsNumberCount() {
      axios.get('/customers/count').then((response) => {
        pagination.value.rowsNumber = response.data
      })
    }

    function onRequest(props) {
      const { page, rowsPerPage } = props.pagination
      fetchFromServer(page - 1, rowsPerPage)
      pagination.value.page = page
      pagination.value.rowsPerPage = rowsPerPage
    }

    function onRowClicked(id) {
      router.push('/customer/' + id)
    }

    return {
      loading,
      columnDefinition,
      pagination,
      customers,
      mappers,
      fetchFromServer,
      getRowsNumberCount,
      onRequest,
      onRowClicked,
    }
  },
  created() {
    this.getRowsNumberCount()
    this.fetchFromServer(0, 10)
  },
}
</script>
